import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { standardOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { deleteTsdMap } from '../../../../store/TsdMap';

export const DefaultTsdMapGridColumnDefs: GridSingleSelectColDef[] = [
  {
    headerName: 'Salesforce TSD',
    field: 'tsd_name',
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: standardOperators(),
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${params.row.tsd_sfid}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.tsd_name}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'tsd_rpm',
    headerName: 'RPM Source',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'actions',
    headerName: '',
    width: 80,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    hideable: false,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <button
        className="-mt-[0.125rem] align-top"
        onClick={() => deleteTsdMap(params.row.id)}>
        <DeleteIcon color="buttonGrey" />
      </button>
    )
  }
];
